/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Recipients_TitleInputs */

const da_privacy_recipients_title = /** @type {(inputs: Privacy_Recipients_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvem får oplysningerne`)
};

/** @type {(inputs: Privacy_Recipients_TitleInputs) => LocalizedString} */
const en_privacy_recipients_title = da_privacy_recipients_title;

/**

* @param {Privacy_Recipients_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_recipients_title = /** @type {((inputs?: Privacy_Recipients_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Recipients_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_recipients_title(inputs)
	return /** @type {LocalizedString} */ ("Hvem får oplysningerne")
});